import { useState, useEffect } from 'react'

const useScreenOrientation = () => {
    const [orientation, setOrientation] = useState(
        matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape'
    )

    const updateOrientation = () => {
        setOrientation(matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape')
    }

    useEffect(() => {
        window.addEventListener('resize', updateOrientation)
        return () => {
            window.removeEventListener('resize', updateOrientation)
        }
    }, [])

    return orientation
}

export default useScreenOrientation
